export default defineNuxtPlugin(() => {
  const deferredPrompt = useState<any>('deferredPrompt', () => null)
  const isStandalone = useState<boolean>('pwaStandalone', () => false)
  const isIos = useState<boolean>('pwaIsIos', () => false)
  const showIosInstallGuide = useState<boolean>(
    'pwaShowIosInstallGuide',
    () => false,
  )
  const canInstall = useState<boolean>('pwaCanInstall', () => false)
  const installed = useState<boolean>('pwaInstalled', () => false)
  const iosGuideDismissalKey = 'pwa-ios-install-guide-dismissed-until'

  const isIosDevice = () =>
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
    (window.navigator.platform === 'MacIntel' &&
      window.navigator.maxTouchPoints > 1)

  const updateIosInstallGuide = () => {
    const dismissedUntil = Number(
      window.localStorage.getItem(iosGuideDismissalKey) || 0,
    )
    showIosInstallGuide.value =
      isIos.value && !isStandalone.value && dismissedUntil <= Date.now()
  }

  // 1) Detect installed (standalone) state
  const checkStandalone = () => {
    const standaloneMM = window.matchMedia?.(
      '(display-mode: standalone)',
    )?.matches
    const iosStandalone = (window.navigator as any).standalone === true
    isStandalone.value = !!(standaloneMM || iosStandalone)
    installed.value = isStandalone.value
    updateIosInstallGuide()
  }

  // Initial + react to changes (Chrome can change at runtime)
  if (import.meta.client) {
    isIos.value = isIosDevice()
    checkStandalone()
    window
      .matchMedia?.('(display-mode: standalone)')
      ?.addEventListener?.('change', checkStandalone)
  }

  // 2) Capture the install prompt (Chrome/Edge/Android)
  window.addEventListener('beforeinstallprompt', (e: any) => {
    e.preventDefault()
    deferredPrompt.value = e
    canInstall.value = !isStandalone.value
  })

  // 3) Mark installed when it happens
  window.addEventListener('appinstalled', () => {
    installed.value = true
    canInstall.value = false
    deferredPrompt.value = null
  })

  return {
    provide: {
      dismissIosInstallGuide: () => {
        window.localStorage.setItem(
          iosGuideDismissalKey,
          String(Date.now() + 14 * 24 * 60 * 60 * 1000),
        )
        showIosInstallGuide.value = false
      },
    },
  }
})
